import {createText} from '@shopify/restyle';
import {Theme} from '../core/theme/restyle';

export const Text = createText<Theme>();
